
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.917 5.5a2.732 2.732 0 012.727 2.737v7.526a2.732 2.732 0 01-2.727 2.737H3.727A2.732 2.732 0 011 15.763V8.237A2.732 2.732 0 013.728 5.5zm8.487 2.015c.337-.168.596-.004.596.36v8.25c0 .361-.267.522-.596.355l-4.578-2.326a.406.406 0 01-.204-.327v-3.695c0-.12.092-.269.204-.325z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    